// extracted by mini-css-extract-plugin
export default {"tabMenu":"styles-module--tabMenu--1lE8x","tabMore":"styles-module--tabMore--3DIuv","tabDescriptionContainer":"styles-module--tabDescriptionContainer--PYcly"};